import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[underline]' })
export class UnderlineDirective implements AfterViewInit {
  @Input('underline') keyword: string;

  constructor(private el: ElementRef) { }

  ngAfterViewInit(): void {
    if (this.keyword !== '' && this.keyword !== undefined) {
      this.apply();
    }
  }

  public apply() {
    const element = this.el.nativeElement;

    const index = element.innerHTML.toLowerCase().indexOf(this.keyword.toLowerCase());
    if (index >= 0) {
      const value = element.innerHTML.substring(index, index + this.keyword.length);
      element.innerHTML = element.innerHTML.replace(value, `<span style="border-bottom: 1px solid #444444">${value}</span>`);
    }
  }
}
